/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./HomepageMenuZh.css";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

class HomepageMenuZh extends Component {
  render() {
    return (
      <div className="HomepageMenuZh-main">
        <div className="HomepageMenuEn-leftContainer">
          <div className="HomepageMenuZh-outsideHeader">
            <div className="HomepageMenuZh-navBar">
              <div
                className="HomepageMenuZh-menuBtn"
                onClick={() => this.props.closeModal()}
              >
                <div className="HomepageMenuZh-menuIcn" />
              </div>

              <div
                className="HomepageMenuZh-CheckPlusLogo"
                onClick={() => this.props.closeModal()}
              />

              <div className="HomepageMenuZh-navBarContainer">
                <Link to="/En">
                  <div className="HomepageMenuZh-settingsContainer">
                    <div className="HomepageMenuZh-settingsTxt">概覽</div>
                  </div>
                </Link>

                <Link to="/EnWhyCheckPlus">
                  <div className="HomepageMenuZh-settingsContainer">
                    <div className="HomepageMenuZh-settingsTxt">
                      為什麼選擇 CheckPlus？
                    </div>
                  </div>
                </Link>

                <Link to="/EnSecurity">
                  <div className="HomepageMenuZh-settingsContainer">
                    <div className="HomepageMenuZh-settingsTxt">系統安全</div>
                  </div>
                </Link>

                <Link to="/EnPricing">
                  <div className="HomepageMenuZh-settingsContainer">
                    <div className="HomepageMenuZh-settingsTxt">費用</div>
                  </div>
                </Link>

                <Link to="/ZhFaq">
                  <div className="HomepageMenuZh-settingsContainer">
                    <div className="HomepageMenuZh-settingsTxt">常見問題</div>
                  </div>
                </Link>

                <Link to="/OrgLogin">
                  <div className="HomepageMenuZh-loginContainer">
                    <div className="HomepageMenuZh-loginTxt">機構登入</div>
                  </div>
                </Link>

                <Link to="/OrgSignup">
                  <div className="HomepageMenuZh-signUpContainer">
                    <div className="HomepageMenuZh-signupTxt">立即登記</div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="HomepageMenuZh-bg" />
      </div>
    );
  }
}

HomepageMenuZh.propTypes = {
  show: PropTypes.bool,
  closeModal: PropTypes.func,
  state: PropTypes.object,
};

export default HomepageMenuZh;
